import { render, staticRenderFns } from "./EditNoteModal.vue?vue&type=template&id=4c1cf13b&scoped=true&"
import script from "./EditNoteModal.vue?vue&type=script&lang=js&"
export * from "./EditNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cf13b",
  null
  
)

export default component.exports